import Button from "components/Buttons/Button";
import ModalComponent from "components/Common/Modal";
import React from "react";

interface IConfirmationModalProps {
  show: boolean;
  showClose?: boolean;
  onHide: () => void;
  onConfirmClick: () => void;
  renderConfirmationMessage: React.ReactNode;
  renderHeader?: React.ReactNode;
  customClass?: string;
  yesButtonLabel?: string;
  noButtonLabel?: string;
}

const ConfirmationModal: React.FC<IConfirmationModalProps> = ({
  show,
  onHide,
  onConfirmClick,
  renderConfirmationMessage,
  renderHeader,
  showClose = false,
  customClass = "",
  yesButtonLabel = "Yes",
  noButtonLabel = "No",
}) => {
  if (!show) {
    return null;
  }

  return (
    <ModalComponent
      containerClass={`${customClass}`}
      onClose={onHide}
      showClose={showClose}
      renderHeader={renderHeader}
    >
      <div className="flex flex-col gap-8">
        {renderConfirmationMessage}
        <div className="flex gap-2 md:flex-row flex-col-reverse">
          <Button
            variant={"secondary"}
            label={noButtonLabel}
            onClick={onHide}
          />
          <Button label={yesButtonLabel} onClick={onConfirmClick} />
        </div>
      </div>
    </ModalComponent>
  );
};

export default ConfirmationModal;
